/**
 * Whether the visitor last pressed with a pointer or used a key.
 *
 * The browser's own `:focus-visible` guesses, and guesses "keyboard" for focus
 * a script moves — the room hands focus back to the button that opened a
 * panel, and the chat puts it in its field — so a visitor who only ever
 * clicked was left with a lit ring and an open tooltip on the last button
 * they pressed. The room's rings and tooltips ask this instead: a ring says
 * where the keys will act, which is worth showing only to somebody using them.
 */

let pointer = false;

export function lastInputWasPointer(): boolean {
  return pointer;
}

/** Marks the page `data-input="pointer"` or `"key"`, for the stylesheet. */
export function trackInputModality(doc: Document): () => void {
  const root = doc.documentElement;
  const onPointer = () => {
    pointer = true;
    root.dataset["input"] = "pointer";
  };
  const onKey = (event: KeyboardEvent) => {
    // A shortcut held with a modifier is not somebody walking the focus.
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    pointer = false;
    root.dataset["input"] = "key";
  };
  doc.addEventListener("pointerdown", onPointer, true);
  doc.addEventListener("keydown", onKey, true);
  return () => {
    doc.removeEventListener("pointerdown", onPointer, true);
    doc.removeEventListener("keydown", onKey, true);
    delete root.dataset["input"];
  };
}
